// extracted by mini-css-extract-plugin
export default {"header":"dQ9m4","title":"Owf2X","message":"FAObd"};